<template>
  <div class="row col-12">
    <div class="col">
      <div class="text-brand-1 text-weight-bold">{{ label }}</div>
      <q-toggle v-model="valor" />
    </div>
  </div>
</template>

<script>
import { ref, watch } from "vue";

export default {
  name: "ComponentTypeToggle",
  emits: ["enviarValor"],
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
    },
    value: {
      type: Boolean,
    },
  },
  setup(props, { emit }) {
    const valor = ref(props.value);

    watch(
      () => props.value,
      () => {
        if (valor.value === props.value) {
          return;
        }
        valor.value = props.value;
      }
    );

    watch(
      () => valor.value,
      () => {
        emit("enviarValor", { value: valor.value, name: props.name });
      }
    );

    return { valor };
  },
};
</script>
